module.exports = __webpack_public_path__ + "static/media/HipAbductionFemale.f0cedf73.svg";